import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime"
import {
  CardStatus,
  CardStatusParam,
  CardType,
  CardTypeParam,
} from "../_entities/card"
import {
  DATE_PERIOD_DEFAULT,
  DatePeriod,
  getDatePeriodParam,
} from "../_entities/date"
import { SearchFilterCondition } from "../_entities/search"
import {
  isConvertibleToCardStatus,
  isConvertibleToCardType,
  isConvertibleToDatePeriod,
  isConvertibleToInteger,
} from "../_validators/urlQueryValidators"

export function classNames(
  ...classes: Array<string | { [key: string]: boolean }>
) {
  const names: string[] = []
  classes.map(c => {
    if (typeof c === "string") {
      names.push(c)
    } else {
      Object.entries(c).forEach(([k, v]) => {
        if (Boolean(v)) {
          names.push(k)
        }
      })
    }
  })
  return names.join(" ")
}

export function getCurrentPage(pageParam: string | string[] | undefined) {
  return isConvertibleToInteger(pageParam) ? Number(pageParam) : 1
}

export function getCurrentDatePeriod(
  pageParam: string | string[] | undefined
): DatePeriod {
  return isConvertibleToDatePeriod(pageParam) ?? DATE_PERIOD_DEFAULT
}

export function getCurrentCardType(
  pageParam: string | string[] | undefined
): CardType[] | undefined {
  return isConvertibleToCardType(pageParam) ?? undefined
}

export function getCurrentCardStatus(
  pageParam: string | string[] | undefined
): CardStatus[] | undefined {
  return isConvertibleToCardStatus(pageParam) ?? undefined
}

export function toSearchParams(searchParams: {
  [key: string]: string | string[] | undefined
}): URLSearchParams {
  const params = new URLSearchParams()
  for (const key in searchParams) {
    const value = searchParams[key]
    if (value === undefined) {
      continue
    }

    if (Array.isArray(value)) {
      for (const val of value) {
        params.append(key, val)
      }
    } else {
      params.set(key, value)
    }
  }
  return params
}

export function handleByFilterCondition(
  router: AppRouterInstance,
  condition: SearchFilterCondition
) {
  const linkUrl = new URL(window.location.href)

  if (condition.searchText != null) {
    condition.searchText === ""
      ? linkUrl.searchParams.delete("text")
      : linkUrl.searchParams.set("text", condition.searchText)
  }
  if (condition.datePeriod != null && condition.datePeriod.length > 0) {
    condition.datePeriod.toString() === DATE_PERIOD_DEFAULT
      ? linkUrl.searchParams.delete("datePeriod")
      : linkUrl.searchParams.set(
          "datePeriod",
          getDatePeriodParam(condition.datePeriod.toString())
        )
  }
  if (condition.cardTypes != null && condition.cardTypes.length > 0) {
    linkUrl.searchParams.set(
      "cardType",
      condition.cardTypes
        .map((value: CardType) => {
          return CardTypeParam.get(value)
        })
        .toString()
    )
  } else {
    linkUrl.searchParams.delete("cardType")
  }
  if (condition.cardStatuses != null && condition.cardStatuses.length > 0) {
    linkUrl.searchParams.set(
      "cardStatus",
      condition.cardStatuses
        .map((value: CardStatus) => {
          return CardStatusParam.get(value)
        })
        .toString()
    )
  } else {
    linkUrl.searchParams.delete("cardStatus")
  }

  const newUrl = linkUrl.toString()
  if (newUrl !== window.location.href) {
    router.push(newUrl)
  }
}
